import validate from "/src/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.12.13_@unocss+reset_5dn2se66p6z3i25vxejh3gni7y/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/src/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.12.13_@unocss+reset_5dn2se66p6z3i25vxejh3gni7y/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  client: () => import("/src/middleware/client.ts")
}